import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundPosition: 'center bottom',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'transparent',
  },
}));

export default function Cover(props) {
  const classes = useStyles();
  return (<div className={classes.root} style={ props.backgroundURL ? { backgroundImage: `url(${props.backgroundURL})`} : {} }>
    {props.children}
  </div>);
}
